import {
  FhirBinary,
  FhirResourceTypes,
  FhirResourceUtils,
  FhirExtractionContext
} from '@oh-vcp/components-common';
import { useEffect } from 'react';

const useFhirResourceEffect = (
  data: any,
  setContent: React.Dispatch<React.SetStateAction<string>>,
  reportType: string,
  setSelectedClinicalReports: React.Dispatch<React.SetStateAction<string[]>>,
  enabled: boolean = true,
  setBinaryItems: React.Dispatch<React.SetStateAction<FhirBinary[]>>,
  context?: FhirExtractionContext
) => {
  useEffect(() => {
    if (!enabled) return;
    FhirResourceUtils.processFhirBundleResource(
      data,
      setContent,
      reportType,
      setSelectedClinicalReports,
      setBinaryItems,
      context
    );
  }, [data, enabled, context]);
};

export default useFhirResourceEffect;
